import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { TrackingEventSource } from '../../../../app/package/base/service/tracking/tracking-service';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import type { UIModal } from '../../ui-modal/ui-modal';

const CName = 'ui-login-modal';

@customElement(CName)
export class UILoginModal extends UIModalServiceModal {
  public onCloseCallback?: (el: UIModal) => void;

  public close() {
    this.onCloseCallback?.(this._modalRef.value!);
    this._modalRef.value?.close();
  }

  render() {
    return html`
      <ui-modal
        ${ref(this._modalRef)}
        .onAction=${() => window.$app.product.gotoLogin('login-modal')}
        .actionButtonLabel=${window.$app.$t.get(I18n.base.login)}
        .onAltAction=${() => window.$app.product.gotoSignup(TrackingEventSource.LOGIN_AND_PLAY)}
        .altActionButtonLabel=${window.$app.$t.get(I18n.base.register)}
        class="modal--centered"
      >
        <div slot="title">You are playing Demo Mode</div>
        <div class="content" slot="main">Log in or register for an account for the full game experience.</div>
      </ui-modal>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UILoginModal;
  }
}
